import { Button, Spinner, makeStyles, tokens } from "@fluentui/react-components";
import { useState } from "react";

import { performLogin } from "@entities/user-tokens";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "16px",
        padding: "24px",
    },
    title: {
        fontSize: tokens.fontSizeBase500,
        fontWeight: tokens.fontWeightSemibold,
        margin: 0,
    },
    message: {
        margin: 0,
        color: tokens.colorNeutralForeground2,
    },
    error: {
        color: tokens.colorStatusDangerForeground1,
        fontSize: tokens.fontSizeBase200,
    },
});

export function LoginPane() {
    const styles = useStyles();
    const [busy, setBusy] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleLogin = async () => {
        setBusy(true);
        setErrorMessage(null);
        const outcome = await performLogin();
        setBusy(false);
        if (outcome.ok) return;
        if (outcome.cancelled) return;
        setErrorMessage(`ログインに失敗しました: ${outcome.detail ?? "unknown"}`);
    };

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>IM 支援アドイン</h1>
            <p className={styles.message}>
                サービスをご利用いただくにはログインが必要です。下のボタンからログインを開始してください。
            </p>
            <Button appearance="primary" onClick={handleLogin} disabled={busy}>
                {busy ? <Spinner size="tiny" label="認証中…" /> : "ログイン"}
            </Button>
            {errorMessage && <p className={styles.error}>{errorMessage}</p>}
        </div>
    );
}
